export default __webpack_public_path__ + "static/ic_logo_black-30cccc291d2cd37cd69f2788c5d0f2dd.svg";